/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import {
    arrayOf, shape, string, bool,
} from 'prop-types';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Image from '../../../common/Image';
import { isEmpty } from '../../../utils/object';
import { secureProtocol } from '../../../utils/secureProtocol';
import { formatPrice } from '../../../utils/formater';

class DesktopProductDetails extends Component {
    subscriptionInterval = (i) => {
        const SUBSCRIPTION_INTERVALS = {
            1: 'Delivers every 1 week',
            4: 'Delivers every 4 weeks',
            6: 'Delivers every 6 weeks',
            8: 'Delivers every 8 weeks',
            30: 'Delivers monthly',
        };
        return SUBSCRIPTION_INTERVALS[i] ? SUBSCRIPTION_INTERVALS[i] : i;
    }

    productDetail = (
        key,
        {
            productName, prdImgTmn: productImage, productSku,
            quantity, price, interval,
        },
        isPassport,
        isLastItem,
    ) => {
        const productImageURL = productImage ? secureProtocol(productImage) : productImage;
        return (
            <Grid key={key} className="desktop-product-container padding-10" container>
                <Grid item xs={8}>
                    <div

                        className={`split desktop-product-detail margin-bottom ${
                            isLastItem ? 'last' : ''
                        }`}
                    >
                        <div className="product-image">
                            <Image src={productImageURL} alt="" />
                        </div>
                        <div className="product-description">
                            <div className="product-name">{productName}</div>
                            {interval ? (
                                <div className="subscription">
                                    <span className="subscription-delivery">{this.subscriptionInterval(interval)}</span>
                                    <Link to="/account/subscriptions">Manage Subscriptions</Link>
                                </div>
                            ) : ''}
                            <div className="product-sku">
                                <div className="gray-color uppercase">Item #: <span className="bold">{productSku}</span></div>
                            </div>
                        </div>
                    </div>
                </Grid>
                <Grid item xs={2}>
                    <div>
                        <span className="bold -price-label">Qty: </span>
                        {quantity}
                    </div>
                </Grid>
                <Grid item xs={2}>
                    <div>
                        <div>
                            <span className="bold -price-label">Price: </span>$
                            {formatPrice(price)}
                        </div>
                    </div>
                </Grid>
            </Grid>
        );
    };

    render() {
        const { itemDetailList, isPassport } = this.props;
        if (isEmpty(itemDetailList)) return null;
        return itemDetailList.map((product, key) => this.productDetail(
            key,
            product,
            isPassport,
            itemDetailList.length - 1 === key,
        ));
    }
}

DesktopProductDetails.defaultProps = {
    itemDetailList: [],
    isPassport: false,
};

DesktopProductDetails.propTypes = {
    itemDetailList: arrayOf(
        shape({
            arrivalEndDate: string,
            arrivalStartDate: string,
            cardMessage: string,
            cardMsgEnable: string,
            deliveryDate: string,
            duration: string,
            flexDate: string,
            flexGuaranteedFlag: string,
            flexMessage: string,
            interval: string,
            itemDiscountAmount: string,
            itemType: string,
            prdImgCtg: string,
            prdImgTmn: string,
            price: string,
            productBrand: string,
            productName: string,
            productSku: string,
            promCode: string,
            quantity: string,
            seoUrl: string,
            sequenceNumber: string,
            shipDate: string,
        }),
    ),
    isPassport: bool,
};

export default DesktopProductDetails;
